<template>
  <div :class="activateCompetency ? 'active' : 'active'">
    <vs-popup
      fullscreen
      class="profile-card"
      title="Sesiones"
      :active.sync="typeFormPopup"
    >
      <iframe
        :src="src"
        fullscreen
        frameBorder="0"
        class="editor-iframe"
      ></iframe>
    </vs-popup>
    <h5 class="mb-2 mt-10 font-bold">Sesiones</h5>
    <div class="flex -mx-3 relative">
      <div class="px-3 lg:w-1/3 sm:w-1/2 w-full">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div
              :class="
                activateCompetency
                  ? 'active-image-wrapper'
                  : 'active-image-wrapper'
              "
              class="ml-4"
            >
              <img
                :src="libraryItemList[0].imageUrl"
                width="20%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[0].title }}</h5>
            <p class="text-sm">{{ libraryItemList[0].description }}</p>
            <p class="text-sm mt-2" style="color: #ff6900">12-Sep-2022</p>

          </div>
          <template slot="footer">
            <div class="flex items-center">
              <vs-button
                class="card-footer-text mr-1"
                @click="meetingPopup(1)"
                color="#7B40E9"
                relief
                style="color: white; border-radius: 5px"
                >Reservar</vs-button
              >
              <!--              <arrow-right-icon-->
              <!--                size="1x"-->
              <!--                style="color: #3089f0;"-->
              <!--                class="footer-icon"-->
              <!--              ></arrow-right-icon>-->
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 sm:w-1/2 sm:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div
              :class="
                activateCompetency
                  ? 'active-image-wrapper'
                  : 'active-image-wrapper'
              "
              class="ml-4"
            >
              <img
                :src="libraryItemList[1].imageUrl"
                width="20%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[1].title }}</h5>
            <p class="text-sm">{{ libraryItemList[1].description }}</p>
            <p class="text-sm mt-2" style="color: #ff6900">12-Sep-2022</p>

          </div>
          <template slot="footer">
            <div class="flex items-center">
              <vs-button
                class="card-footer-text mr-1"
                color="#7B40E9"
                @click="meetingPopup(2)"
                relief
                style="color: white; border-radius: 5px"
                >Reservar</vs-button
              >
              <!--              <arrow-right-icon-->
              <!--                size="1x"-->
              <!--                style="color: #3089f0;"-->
              <!--                class="footer-icon"-->
              <!--              ></arrow-right-icon>-->
            </div>
          </template>
        </vx-card>
      </div>
      <div class="px-3 lg:w-1/3 lg:block hidden">
        <vx-card class="overflow-hidden" noShadow>
          <template slot="no-body">
            <div
              :class="
                activateCompetency
                  ? 'active-image-wrapper'
                  : 'active-image-wrapper'
              "
              class="ml-4"
            >
              <img
                :src="libraryItemList[2].imageUrl"
                width="20%"
                height="auto"
              />
            </div>
          </template>
          <div class="training-item-body">
            <h5 class="mb-2 font-bold">{{ libraryItemList[2].title }}</h5>
            <p class="text-sm">{{ libraryItemList[2].description }}</p>
            <p class="text-sm mt-2" style="color: #ff6900">12-Sep-2022</p>
          </div>
          <template slot="footer">
            <div class="flex items-center">
              <vs-button
                class="card-footer-text mr-1"
                @click="meetingPopup(3)"
                color="#7B40E9"
                relief
                style="color: white; border-radius: 5px"
                >Reservar</vs-button
              >
              <!--              <arrow-right-icon-->
              <!--                size="1x"-->
              <!--                style="color: #3089f0;"-->
              <!--                class="footer-icon"-->
              <!--              ></arrow-right-icon>-->
            </div>
          </template>
        </vx-card>
      </div>
      <!--      <div class="view-more" v-if="activateCompetency && boardSlug" >-->
      <!--        <a  @click="activeMsp()" :href="`/${organizationSlug}/${boardSlug}/${userId}/library`"> <img src="../../../../../assets/images/icons/gala/right-arrow-blue.svg" style="color: #3089f0;" /></a>-->
      <!--      </div>-->
      <!--      <div class="view-more" v-else-if="activateCompetency" >-->
      <!--        <a   @click="activeMsp()"  :href="`/${organizationSlug}/library`" > <img src="../../../../../assets/images/icons/gala/right-arrow-blue.svg" /></a>-->
      <!--      </div>-->
      <!--      <div class="view-more" v-else >-->
      <!--        <img src="../../../../../assets/images/icons/gala/right-arrow-grey.svg" />-->
      <!--      </div>-->
    </div>
  </div>
</template>
<script>
import { ArrowRightIcon } from "vue-feather-icons";

export default {
  components: {
    ArrowRightIcon,
  },
  data() {
    return {
      userId: "",
      boardSlug: "",
      typeFormPopup:false,
      src:'',
      libraryItemList: [
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/Vector.svg",
          title: "Trabajo en equipo",
          description:
            "Cooperación\n" + "Sensibilidad organizacional\n" + "Compromiso",
        },
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/promotion+1.svg",
          title: "Comunicación",
          description:
            "Motivación\n" + "Dar y recibir feedback\n" + "Persuasión",
        },
        {
          itemId: "",
          imageUrl:
            "https://getboarded-backup-new.s3.us-east-2.amazonaws.com/static/time-management+1.svg",
          title: "Gestión emocional",
          description:
            "Inteligencia emocional\n" +
            "Regulación emocional\n" +
            "Autoestima",
        },
      ],
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    autoLoginToken() {
      return this.$store.state.boards.userBoardData.youlabToken;
    },
    userProgress() {
      return this.$store.state.boards.userBoardData.progress;
    },
    activateFeedback() {
      return this.autoLoginToken && this.userProgress >= 1;
    },
    activateCompetency() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    activatePreferences() {
      return this.autoLoginToken && this.userProgress >= 2;
    },
    organizationName() {
      return this.$store.state.organization.orgData.name;
    },
    organizationSlug() {
      return this.$store.state.organization.orgData.slug;
    },
  },
  methods: {
    activeMsp() {},
    meetingPopup(value){
      console.log(this.$store.state.auth.user.firstName);
      console.log(this.$store.state.auth.user.email);
      this.typeFormPopup=true;
      if(value===1){
        this.src='https://gtbrdd.typeform.com/to/vg1hPTTk#event_name=Trabajo%20en%20equipo&creater_email='+this.$store.state.auth.user.email+'&f_name='+this.$store.state.auth.user.firstName+'&date=12/08/2022';
      }
      else if(value===2){
        this.src='https://gtbrdd.typeform.com/to/vg1hPTTk#event_name=Comunicación&creater_email='+this.$store.state.auth.user.email+'&f_name='+this.$store.state.auth.user.firstName+'&date=12/08/2022';
      }else if(value===3){
        this.src='https://gtbrdd.typeform.com/to/vg1hPTTk#event_name=Gestión%20emocional&creater_email='+this.$store.state.auth.user.email+'&f_name='+this.$store.state.auth.user.firstName+'&date=12/08/2022';
      }

    }
  },
  created() {
    let url = this.$route.path.split("/");
    this.boardSlug = url[2];
    this.userId = url[3];
    const orgSlug = url[1];
    if (orgSlug) {
      this.$store
        .dispatch("organization/fetchOrganizationBySlug", orgSlug)
        .then((res) => {
          console.log("res.data", res.data.data[0]);
          this.organizationSlug = res.data.data[0].slug;
          this.organizationName = res.data.data[0].name;
          if (!res.data.data[0].activeMarketplace) this.$router.push("/");
          else {
            this.$store.dispatch("journey/fetchUserSegments", {
              orgId: res.data.data[0]._id,
            });
          }
        })
        .catch((err) => {
          throw err;
        });
    }
  },
};
</script>
<style scoped>
p {
  line-height: unset;
  font-size: unset;
}
section {
  padding: 8rem 0;
}
.active h1,
.active h5 {
  color: #231d4f;
}
.active p {
  color: #848199;
}
.active p.card-footer-text .active .footer-icon {
  color: #dc0032;
}
.inactive h1,
.inactive p,
.inactive h5,
.inactive .footer-icon {
  color: #ccc !important;
}
.inactive div.vx-card {
  border: 1px solid #eaf1fb;
}
.training-item-body {
  min-height: 140px;
}
.image-wrapper img {
  position: absolute;
}
.image-wrapper {
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;
  opacity: 0.2;
}
.editor-iframe {
  width: 100%;
  height: calc(100vh - 150px);
}
.active-image-wrapper {
  position: relative;
  height: 80px;
  width: 100%;
  overflow: hidden;
  opacity: 1;
}
.view-more {
  position: absolute;
  right: -25px;
  top: 275px;
  color: #231d4f;
}
</style>
